// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7a43bf42","977":"1a79a3b4"}[chunkId] + ".chunk.js";
};